const PACKAGE_TYPE = {
  DOCUMENT: 'Document',
  FOOD: 'Food & Beverages',
  GROCERIES: 'Fresh Groceries',
  CLOTHES: 'Clothes',
  OTHERS: 'Others',
};

export default PACKAGE_TYPE;
